import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createInstance, OptimizelyProvider, useDecision } from '@optimizely/react-sdk';
import { usePersonalLoan } from 'shared/hooks';

const optimizely = createInstance({
  sdkKey: process.env.REACT_APP_OPTIMIZELY_SDK_KEY,
  datafileOptions: {
    autoUpdate: true,
    updateInterval: 300000, // 5 minutes in milliseconds
  },
});

export const FeatureFlagProvider = ({ children }) => {
  const [sessionUuid, setSessionUuid] = useState();
  const { uuid } = usePersonalLoan(false);

  useEffect(() => {
    if (uuid) setSessionUuid(uuid);
  }, [uuid]);

  return (
    <OptimizelyProvider
      optimizely={optimizely}
      {...(!!sessionUuid && { user: { id: sessionUuid } })}
    >
      {children}
    </OptimizelyProvider>
  );
};
FeatureFlagProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useFeatureFlag = (featureFlagName, autoUpdate = true) => {
  const [{ enabled, variables }] = useDecision(featureFlagName, { autoUpdate });

  return {
    isEnabled: enabled,
    variables,
  };
};
